<template>
    <div class="modal-overlay">
        <div class="modal-card">
            <div class="modal-header">
                <h6 class="modal-title text-white"><i class="fa fa-lock"></i> Change Password</h6>
                <button class="modal-close" @click="$emit('close')">
                    <i class="fa fa-times"></i>
                </button>
            </div>
            <div class="modal-body">
                <div class="mb-2">
                    <label class="filter-label">Old Password</label>
                    <input
                        v-model="form.old_password"
                        type="password"
                        class="form-control"
                        placeholder="Enter current password"
                    />
                </div>
                <div class="mb-2">
                    <label class="filter-label">New Password</label>
                    <input
                        v-model="form.password"
                        type="password"
                        class="form-control"
                        placeholder="Enter new password"
                    />
                </div>
                <div class="mb-2">
                    <label class="filter-label">Confirm New Password</label>
                    <input
                        v-model="form.password_confirmation"
                        type="password"
                        class="form-control"
                        placeholder="Confirm new password"
                    />
                </div>
            </div>
            <div class="modal-footer">
                <button @click="$emit('close')" class="btn btn-outline-secondary btn-sm">Cancel</button>
                <button @click="submit" :disabled="loading" class="btn btn-primary btn-sm">
                    {{ loading ? 'Updating...' : 'Update Password' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject, reactive, ref } from 'vue';
import handleSdm from '@/services/modules/sdm/sdm';
import {useRoute} from "vue-router";

const emit = defineEmits(['close']);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const { changePassword } = handleSdm();
const $route = useRoute()
const loading = ref(false);
const form = reactive({
  old_password: '',
  password: '',
  password_confirmation: ''
});

const resetForm = () => {
    form.old_password = '';
    form.password = '';
    form.password_confirmation = '';
};

const submit = async () => {
    if (!form.old_password || !form.password || !form.password_confirmation) {
        showError('All password fields are required.');
        return;
    }
    if (form.password !== form.password_confirmation) {
        showError('New password and confirm password do not match.');
        return;
    }
    loading.value = true;
    await changePassword({
        company_id: $route.params.companyId,
        old_password: form.old_password,
        password: form.password,
        password_confirmation: form.password_confirmation,
    }).then(res => {
        if (!res.status) {
          showError(res.message);
          return;
        }
        showSuccess(res.message);
        resetForm();
        emit('close');
    }).catch(() => {
      showError('Something went wrong.');
    })
    .finally(() => {
      loading.value = false;
    });
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    backdrop-filter: blur(2px);
}

.modal-card {
    background: #fff;
    border-radius: 14px;
    width: 100%;
    max-width: 400px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.2);
    overflow: hidden;
    margin: 1rem;
}

.modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    background: linear-gradient(90deg, #6366f1, #818cf8);
    color: #fff;
}

.modal-title {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
}

.modal-close {
    background: none;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 1rem;
    opacity: 0.8;
    transition: opacity 0.15s;
    padding: 0;
    line-height: 1;
}

.modal-close:hover { opacity: 1; }

.modal-body {
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.modal-footer {
    padding: 0.75rem 1.25rem;
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    background: #f8fafc;
    border-top: 1px solid #e5e7eb;
}

.filter-label {
    font-size: 0.78rem;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}
</style>
